var React = require('react');

function IconBetslip (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.23879 1.66669C4.19036 1.67104 3.34307 2.41596 3.34308 3.33335L3.33447 16.8894C3.33403 17.5879 4.03159 18.0716 4.6856 17.8263L10.0002 15.8334L15.3158 17.8267C15.9695 18.0718 16.6669 17.5886 16.6669 16.8904V3.33335C16.6638 2.41418 15.8131 1.66966 14.7626 1.66669H5.23879ZM10.0007 14.0163L5.23879 15.8334V4.33335C5.23879 3.78107 5.68651 3.33335 6.23879 3.33335H13.7626C14.3149 3.33335 14.7626 3.78107 14.7626 4.33335V15.8334L10.0007 14.0163Z","fill":"white"}));
}

IconBetslip.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconBetslip;

IconBetslip.default = IconBetslip;
